module.exports = __webpack_public_path__ + "static/shifts-card-1-1a9c7a2975cda336ae34008b5575c4a4.png";